// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"54086e7f","816":"1f313150"}[chunkId] + ".chunk.js";
};